import * as Sentry from '@sentry/react';

const isStaging = import.meta.env.VITE_SENTRY_ENV === 'development';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
    ...(isStaging ? [Sentry.browserTracingIntegration({})] : []),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: isStaging ? [import.meta.env.VITE_API_ENDPOINT, import.meta.env.VITE_AWS_APPSYNC_GRAPHQL_ENDPOINT] : [],
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,
  environment: import.meta.env.VITE_SENTRY_ENV,
  enabled: true,
});
